import { writable } from "svelte/store";
let FuturePricesStore;
export default FuturePricesStore = writable([]);
